const findNearestValue = <T extends Record<string, number>>(givenObject: Partial<T>, schemaKeys: Array<keyof T>, index: number): number => {
  // Search backwards
  for (let i = index - 1; i >= 0; i--) {
    const key = schemaKeys[i];
    if (!key) continue;
    if (key in givenObject) {
      return givenObject[key] ?? 0;
    }
  }

  // Search forwards
  for (let i = index + 1; i < schemaKeys.length; i++) {
    const key = schemaKeys[i];
    if (!key) continue;
    if (key in givenObject) {
      return givenObject[key] ?? 0;
    }
  }

  // Default if no nearest value is found
  return 0;
};

export const fillMissingKeys = <T extends string>(schemaArray: T[], givenObject: Partial<Record<T, number>>): Record<T, number> => {
  // Convert the array schema to an object with initial values
  const schema = schemaArray.reduce(
    (acc, key) => {
      acc[key] = 0;
      return acc;
    },
    {} as Record<T, number>,
  );

  // Get all keys from the schema
  const schemaKeys = Object.keys(schema) as Array<T>;

  for (const key of schemaKeys) {
    // Check if the key exists in the givenObject and has a value
    if (key in givenObject && typeof givenObject[key] === 'number') {
      schema[key] = givenObject[key] ?? 0;
    } else {
      // Find the nearest value
      // Assuming findNearestValue is implemented correctly
      const nearestValue = findNearestValue(givenObject, schemaKeys, schemaKeys.indexOf(key));
      if (typeof nearestValue === 'number') {
        schema[key] = nearestValue;
      }
    }
  }

  return schema;
};
